<template>
  <div
    class="app-root"
    :style="appStyle"
  >
    <div id="scroll-box"></div>
    <template v-if="$route.meta.isReportPage">
      <router-view />
    </template>
    <template v-else>
      <layoutHeader v-if="headerHeight"></layoutHeader>
      <div class="app-container col-block flex-start">
        <div class="app-block col-block stretch">
          <div class="app-pages col-block" :style="{ minHeight: (windowHeight - headerHeight) + 'px' }">
            <div v-if="appBackground" class="app-background" :style="appBackground"></div>
            <div class="app-main-container col-block width-full" :style="{ flex: 1 }">
              <router-view :key="routerID" />
            </div>
          </div>
          <layoutFooter v-if="footerHeight"></layoutFooter>
        </div>
      </div>
      <layoutModal></layoutModal>
      <layoutToast></layoutToast>
      <layoutLoading v-if="isLoading"></layoutLoading>
      <layoutUploading v-if="isUploading !== undefined" :content="isUploading"></layoutUploading>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import layoutHeader from '@/components/layout/header.vue'
import layoutFooter from '@/components/layout/footer.vue'
import layoutModal from '@/components/layout/modal.vue'
import layoutToast from '@/components/layout/toast.vue'
import layoutLoading from '@/components/layout/loading.vue'
import layoutUploading from '@/components/layout/uploading.vue'
import responsitiveData from '@/mixins/responsitiveData.vue'
import styleData from '@/mixins/styleData.vue'
import { checkUser } from '@/constants/global/router'

export default {
  components: {
    layoutHeader,
    layoutFooter,
    layoutModal,
    layoutToast,
    layoutLoading,
    layoutUploading
  },
  mixins: [
    responsitiveData,
    styleData
  ],
  metaInfo () {
    return {
      title: 'COMPASS 検査所'/* ___ */
    }
  },
  data () {
    return {
      routerID: (new Date()).getTime()
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'isLoading',
      'isUploading'
    ]),
    appStyle () {
      return {
        ...this.layoutStyles,
        ...this.colorStyles
      }
    },
    appBackground () {
      // if (this.$route.meta.background) {
      //   let img = (!['mobile'].includes(this.windowType) || !this.$route.meta.background.mimg) ? this.$route.meta.background.img : this.$route.meta.background.mimg
      //   return {
      //     'background-image': 'url(' + require('@/assets/backgrounds/' + img) + ')',
      //     ...this.$route.meta.background.style
      //   }
      // }
      return null
    }
  },
  watch: {
    '$route' () {
      this.addModalAction()
      document.getElementsByClassName('app-root')[0].scrollTo({ top: 0, left: 0 })
      window.dispatchEvent(new Event('resize'))
    },
    async 'user' (nv, ov) {
      if (ov !== undefined) {
        await this.fetchGlobalData(nv)
        let result = await checkUser(this.$route, false)
        if (result !== undefined) {
          this.$router.push(result)
        } else {
          this.routerID = (new Date()).getTime()
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'addModalAction'
    ]),
    async fetchGlobalData (user) {
    }
  }
}
</script>

<style lang="sass">
@import sass/style
</style>
